import useCurrency from '@growdash/growintel/hooks/useCurrency';
import OverviewCard from '../components/overview-card';
import { NewClosedRestaurants } from '../types';

type Props = {
  restaurants: NewClosedRestaurants | undefined;
  avgPrice?: number | null;
};

export default function OverviewCardsView({
  restaurants,
  avgPrice = 0,
}: Props) {
  const currency = useCurrency();
  return (
    <>
      <OverviewCard
        title="New restaurants"
        value={restaurants?.new?.items?.length ?? 0}
        className="col-span-full sm:col-span-4"
        toolTipInfo="How many new restaurants have started their operations in the given period"
      />
      <OverviewCard
        title="Closed restaurants"
        value={restaurants?.closed?.items?.length ?? 0}
        className="col-span-full sm:col-span-4"
        toolTipInfo="How many restaurants have ended their operations in the given period"
      />
      <OverviewCard
        title="Average price"
        value={`${avgPrice?.toFixed(2) ?? '-'} ${currency}`}
        className="col-span-full sm:col-span-4"
      />
    </>
  );
}
